module.exports = __webpack_public_path__ + "Flag-720.7abcfd17ddf56cae1d09584df4d03924.svg";